import layout from '@/views/layout/layout.vue'
const productExtendList = r => require.ensure([], () => r(require('@/views/wechatExcellent/productExtend/list.vue')), 'group-wechatExcellent-productDealer')

const productExtend = [
  {
    path: '/wechatExcellent/productExtend',
    name: 'wechatExcellent-productExtend',
    component: layout,
    redirect: '/wechatExcellent/productExtend/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: productExtendList,
        name: 'wechatExcellent-productExtend-list',
        meta: {
          displayName: '商品扩展信息',
          requireAuth: true
        }
      }
    ]
  }
]

export default productExtend



// WEBPACK FOOTER //
// ./src/router/wechatExcellent/productExtend.js